import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Box,
  Badge,
  Flex
} from '@chakra-ui/react';
import { MODEL_DESCRIPTIONS } from '../../utils/constants';
import { formatModelName } from '../../utils/helpers';

interface MatchStatsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedMatchStats: any;
}

export const MatchStatsModal = ({ isOpen, onClose, selectedMatchStats }: MatchStatsModalProps) => {
  if (!selectedMatchStats) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg="gray.800" color="white">
        <ModalHeader>Match Statistics</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="start">
            <Text fontSize="lg" fontWeight="bold">Model Similarity Scores:</Text>
            {selectedMatchStats.all_matches?.map((modelMatch: any, idx: number) => (
              <Box 
                key={idx}
                w="full"
                p={3}
                bg="gray.700"
                borderRadius="md"
              >
                <Flex justify="space-between" align="center" mb={1}>
                  <Text fontWeight="medium">{formatModelName(modelMatch.model)}</Text>
                  <Badge 
                    colorScheme={
                      modelMatch.similarity >= 0.7 ? "green" :
                      modelMatch.similarity >= 0.5 ? "yellow" : "red"
                    }
                  >
                    {(modelMatch.similarity * 100).toFixed(1)}%
                  </Badge>
                </Flex>
                <Text fontSize="sm" color="gray.400">
                  {MODEL_DESCRIPTIONS[modelMatch.model] || 'No description available'}
                </Text>
              </Box>
            ))}
            <Text fontSize="sm" color="gray.400" mt={2}>
              Models used: {selectedMatchStats.model_results?.join(', ').split('_').map(formatModelName).join(', ')}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 